import React, { useEffect, useRef, useState } from "react";
import useJumboContentLayout from "@jumbo/hooks/useJumboContentLayout";
import { ToastContainer } from "react-toastify";
import { Grid } from "@mui/material";
import { useJumboLayoutSidebar } from "@jumbo/hooks";
import PropTypes from "prop-types";

const JumboContentLayoutMain = ({ children, backgroundColor = "#fdfdfd" }) => {
  const [containerWidth, setContainerWidth] = useState(null);
  const mainDivRef = useRef(null); // Create a ref for the main div

  const { sidebarOptions } = useJumboLayoutSidebar();
  const contentLayout = useJumboContentLayout();

  useEffect(() => {
    if (mainDivRef.current) {
      setContainerWidth(mainDivRef.current.clientWidth);
    }
  }, []);


  return (
    <Grid
      ref={mainDivRef}
      // sx={{
      //   display: "flex",
      //   flex: 1,
      //   minWidth: 0,
      //   flexDirection: "column",
      //   minHeight: "100%",
      //   backgroundColor: backgroundColor,

      //   mt: "-30px",
      //   mb: "-50px",
      //   ml: { xs: "-30px", md: "-49px" },
      //   mr: { xs: "-32px", md: "-50px" },
      //   pt: 5,
      //   pb: 2,
      //   pl: sidebarOptions.open ? { xl: "4%", lg: "7%", md: "6%", xs: "3%" } : { xll: "8%", xl: "8.4%", lg: "10%", md: "17%", xs: "3%" },
      //   pr: sidebarOptions.open ? { xl: "10%", lg: "7.3%", md: "6%", xs: "3%" } : { xll: "8%", xl: "8.4%", lg: "10%", md: "16%", xs: "3%" },
      //   ...contentLayout?.main?.sx,
      // }}

      sx={(theme) => ({
        display: "flex",
        flex: 1,
        flexDirection: "column",
        minWidth: 0,
        minHeight: "100%",
        backgroundColor,

        // Use theme spacing instead of fixed pixels
        mt: `-${theme.spacing(4)}`,
        mb: `-${theme.spacing(6)}`,
        ml: { xs: `-${theme.spacing(4)}`, md: `-${theme.spacing(6)}` },
        mr: { xs: `-${theme.spacing(4)}`, md: `-${theme.spacing(6)}` },

        pt: theme.spacing(5),
        pb: theme.spacing(4),

        pl: sidebarOptions.open
          ? { xl: "4%", lg: "7%", md: "6%", xs: "3%" }
          : { xl: "8%", lg: "10%", md: "17%", xs: "3%" },
        pr: sidebarOptions.open
          ? { xl: "10%", lg: "7.3%", md: "6%", xs: "3%" }
          : { xl: "8%", lg: "10%", md: "16%", xs: "3%" },

        ...contentLayout?.main?.sx,
      })}
      className="CmtLayout-main"
    >
      <ToastContainer autoClose={3000} />
      {children}
    </Grid>
  );
};

JumboContentLayoutMain.propTypes = {
  children: PropTypes.node,
  backgroundColor: PropTypes.string,
}

export default JumboContentLayoutMain;
